<section class="container-style">
    <div class="pt-1">
        <app-custom-table [showRecover]="true" [headers]="header" [data]="detailData" [actions]="tableActions"
            [previousFilters]="filters" [isFilterPersistent]="false"
            (onRecoverData)="getAllGeneralParameterWithPaginationAsync()" (onAction)="onAction($event)"
            (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
        </app-custom-table>
    </div>
</section>